'use client'

import type { Blog } from '@/payload-types'
import { BlogFeaturedCard } from './BlogFeaturedCard'
import { CardCarousel } from '@/components/ui/card-carousel'

interface Props {
  blogs: Blog[]
  autoplayDelay?: number
}

export function BlogCardCarousel({ blogs, autoplayDelay = 10000 }: Props) {
  return (
    <CardCarousel
      items={blogs}
      keyExtractor={(b) => String(b.id)}
      renderDarkCard={(blog) => <BlogFeaturedCard blog={blog} variant="dark" />}
      renderLightCard={(blog) => <BlogFeaturedCard blog={blog} variant="light" />}
      ariaLabel="Related articles carousel"
      autoplayDelay={autoplayDelay}
    />
  )
}
